import Bugsnag from '@bugsnag/js'
import { Box, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import DetailCalculation from 'module/payroll/global-components/DetailCalculation'
import EmployeeList from 'module/payroll/global-components/EmployeeList'
import React from 'react'
import { useMutation } from 'react-query'
import {
  downloadSelectedEmployeePayslip,
  sendSelectedEmployeePayslip,
} from 'services/api/modules/payroll/payroll-history'
import { downloadResponseFile } from 'services/helper/fileDownload'

const SummaryDetails = ({ drawerState, handleDrawer, details, time_id, sendPayslip, ...rest }) => {
  const { mutate: downloadSelectedPayslip, isLoading: loadingDownloadSelectedPayslip } =
    useMutation(downloadSelectedEmployeePayslip, {
      onSuccess: (res) => {
        downloadResponseFile(res, {
          fileName: `payslip_${details.name}.zip`,
          contentType: 'application/zip',
          successMessage: 'Payslip downloaded.',
        })
      },
      onError: (error) => {
        if (error.status === 422) {
          console.log(error)
        } else {
          Bugsnag.notify(error.data)
        }
      },
    })
  const { uploadingPayslip, regeneratePayslip, regeneratingPayslip } = rest
  const handleDownloadPayslip = () => {
    let data = {
      selected_employee: [
        {
          employee_id: details.id,
          checked: true,
        },
      ],
    }
    downloadSelectedPayslip({ time_id, data })
  }

  const { mutate: sendIndividuPayslip, isLoading: loadingSendIndividuPayslip } = useMutation(
    sendSelectedEmployeePayslip,
    {
      onSuccess: () => {
        alert(`Succesfully send payslip to ${details.name}`)
      },
      onError: (error) => {
        if (error.status === 422) {
          console.log(error)
        } else {
          Bugsnag.notify(error.data)
        }
      },
    }
  )
  const handleSendPayslip = () => {
    let data = {
      selected_employee: [
        {
          employee_id: details.id,
          checked: true,
        },
      ],
    }
    sendIndividuPayslip({ time_id, data })
  }
  return (
    <AdxDrawerComponent
      state={drawerState}
      anchor="right"
      onClose={handleDrawer}
      headerprops={
        <Box
          sx={{
            display: 'flex',
            flex: 'row',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <EmployeeList avatar={details?.avatar} name={details.name} position={details.position} />
        </Box>
      }
      footerprops={
        <>
          {sendPayslip && uploadingPayslip && (
            <Box display="flex" flexDirection="column" gap={1} width="100%">
              <Typography color="light-gray-text.main" textAlign="center">
                Regenerating payslip...
              </Typography>

              <Box display="flex" justifyContent="center" gap={1} width="100%">
                <AdxButton
                  variant={'outlined'}
                  disabled
                  sx={{ width: 'calc(100% * 2 / 5)' }}
                >
                  Download payslip
                </AdxButton>
                <AdxButton
                  variant={'contained'}
                  disabled
                  sx={{ width: 'calc(100% * 3 / 5)' }}
                >
                  Send payslip via email
                </AdxButton>
              </Box>
            </Box>
          )}

          {sendPayslip && !uploadingPayslip && (
            <Box display="flex" justifyContent="center" gap={1} width="100%">
              {loadingDownloadSelectedPayslip ? (
                <AdxButton variant={'outlined'} isLoading sx={{ width: 'calc(100% * 2 / 5)' }} />
              ) : (
                <AdxButton
                  variant={'outlined'}
                  onClick={handleDownloadPayslip}
                  sx={{ width: 'calc(100% * 2 / 5)' }}
                >
                  Download payslip
                </AdxButton>
              )}
              {loadingSendIndividuPayslip ? (
                <AdxButton isLoading sx={{ width: 'calc(100% * 3 / 5)' }} />
              ) : (
                <AdxButton
                  variant={'contained'}
                  onClick={handleSendPayslip}
                  sx={{ width: 'calc(100% * 3 / 5)' }}
                >
                  Send payslip via email
                </AdxButton>
              )}
            </Box>
          )}
        </>
      }
    >
      <Box display="flex" flexDirection="column" justifyContent="space-between">
        <Box>
          <Typography
            variant="body2"
            textAlign="center"
            color="light-gray-text.main"
            sx={{ bgcolor: 'gray-background.main', py: 2 }}
          >
            Payment details
          </Typography>
          <DetailCalculation data={details} time_id={time_id} />
        </Box>
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              my: 1,
              color: 'light-gray-text.main',
            }}
          >
            <Typography>Net pay</Typography>
            <Typography
              variant="subtitle1"
              color={details?.status === 1 ? 'yellow-01.main' : 'dark-text.main'}
            >{`RM ${details?.salary?.nett}`}</Typography>
          </Box>

          {sendPayslip && regeneratePayslip && !uploadingPayslip && (
            <Box display="flex" justifyContent="flex-end" sx={{ mt: 4 }}>
              <Typography
                component="button"
                type="button"
                onClick={() => regeneratePayslip(details.id)}
                disabled={regeneratingPayslip || !details.id}
                sx={{
                  p: 0,
                  border: 0,
                  bgcolor: 'transparent',
                  color: regeneratingPayslip ? 'light-gray-text.main' : 'alternate.main',
                  cursor: regeneratingPayslip || !details.id ? 'default' : 'pointer',
                  font: 'inherit',
                  textDecoration: 'underline',
                  textUnderlineOffset: '2px',
                }}
              >
                {regeneratingPayslip ? 'Regenerating payslip...' : 'Regenerate payslip'}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </AdxDrawerComponent>
  )
}

export default SummaryDetails
